import React from "react";
import useDarkMode from "@/hooks/useDarkMode";
import { Link } from "react-router-dom";
import useWidth from "@/hooks/useWidth";

import MainLogo from "@/assets/images/logo/bookworm_logo.jpeg";
import LogoWhite from "@/assets/images/logo/bookworm_logo.jpeg";
import MobileLogo from "@/assets/images/logo/bookworm_logo.jpeg";
import MobileLogoWhite from "@/assets/images/logo/bookworm_logo.jpeg";
const Logo = () => {
  const [isDark] = useDarkMode();
  const { width, breakpoints } = useWidth();

  return (
    <div>
      <Link to="">
        {width >= breakpoints.xl ? (
          <img src={isDark ? LogoWhite : MainLogo} alt="Bookworm" className="h-9 w-auto object-contain rounded-lg" />
        ) : (
          <img src={isDark ? MobileLogoWhite : MobileLogo} alt="Bookworm" className="h-8 w-8 object-contain rounded-lg" />
        )}
      </Link>
    </div>
  );
};

export default Logo;
